import { Users } from "lucide-react";
import CrudPage from "@/components/CrudPage";
import { StatusBadge } from "@/components/common";
import { inr, CITIES } from "@/lib/format";

const sections = [
  {
    title: "Owner",
    fields: [
      { key: "name", label: "Owner Name", required: true },
      { key: "mobile", label: "Mobile", type: "tel" },
      { key: "alt_mobile", label: "Alternate Mobile", type: "tel" },
      { key: "city", label: "City", type: "select", options: CITIES },
      { key: "pan", label: "PAN" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
    ],
  },
  {
    title: "Vehicles & Rates",
    fields: [
      { key: "vehicles", label: "Vehicles (number · model, one per line)", type: "textarea", span: 3, rows: 3, placeholder: "MH-15-AB-1234 · Dzire\nMH-21-CD-5678 · Ertiga" },
      { key: "rate_8hr_80km", label: "Rate 8hr/80km (₹)", type: "number" },
      { key: "extra_km_rate", label: "Extra KM Rate (₹)", type: "number" },
      { key: "outstation_rate_per_km", label: "Outstation ₹/km", type: "number" },
    ],
  },
  {
    title: "Payment Details",
    fields: [
      { key: "bank_name", label: "Bank" },
      { key: "account_number", label: "Account Number" },
      { key: "ifsc", label: "IFSC" },
      { key: "upi_id", label: "UPI ID" },
      { key: "notes", label: "Notes", type: "textarea", span: 2, rows: 2 },
    ],
  },
];

const columns = [
  { label: "Owner", render: (o) => <div><div className="font-semibold">{o.name}</div><div className="text-xs text-muted-foreground">{o.mobile}</div></div> },
  { label: "City", render: (o) => o.city || "-" },
  { label: "Vehicles", render: (o) => <div className="text-xs font-mono whitespace-pre-line max-w-[240px]">{o.vehicles || "-"}</div> },
  { label: "8hr/80km", render: (o) => <span className="num">{o.rate_8hr_80km ? inr(o.rate_8hr_80km) : "-"}</span> },
  { label: "Extra KM", render: (o) => <span className="num">{o.extra_km_rate ? `${inr(o.extra_km_rate)}/km` : "-"}</span> },
  { label: "Status", render: (o) => <StatusBadge value={o.status || "Active"} /> },
];

export default function Owners() {
  return (
    <CrudPage resource="owners" eyebrow="Masters" title="Market Vehicle Owners" singular="Owner" icon={Users}
      subtitle="Third-party vehicle owners across Sambhajinagar, Nashik, Shirdi and Jalna — with their rates and payment details."
      sections={sections} columns={columns} defaults={{ status: "Active", city: CITIES[0] }} />
  );
}
